import angular from 'angular';
import { DivisionalCommissionPoliciesDashboardComponent } from './divisional-commission-policies-dashboard.component';
import { EditMultiPlayCommissionPolicyComponent } from './edit-multi-play-commission-policy.component';
import { EditProductCommissionPolicyComponent } from './edit-product-commission-policy.component';
import { MultiPlayCommissionPolicyListComponent } from './multi-play-commission-policy-list.component';
import { ProductCommissionPolicyListComponent } from './product-commission-policy-list.component';
import { MultiPlayCommissionPolicyArchiveService } from './multi-play-commission-policy-archive.service';
import { ProductCommissionPolicyArchiveService } from './product-commission-policy-archive.service';

export const ProductCommissionModule = angular
    .module("apex.mainApp.product.commission", [])
    .component("apexDivisionalPayoutPoliciesDashboard", DivisionalCommissionPoliciesDashboardComponent)
    .component("apexEditMultiPlayCommissionPolicy", EditMultiPlayCommissionPolicyComponent)
    .component("apexEditProductCommissionPolicy", EditProductCommissionPolicyComponent)
    .component("apexMultiPlayCommissionPolicyList", MultiPlayCommissionPolicyListComponent)
    .component("apexProductCommissionPolicyList", ProductCommissionPolicyListComponent)
    .factory("multiPlayCommissionPolicyArchiveService", MultiPlayCommissionPolicyArchiveService)
    .factory("productCommissionPolicyArchiveService", ProductCommissionPolicyArchiveService)
    .name;
